module.exports = __webpack_public_path__ + "media/images/top/howto-06-fc1900c911f91fbf95f33f2a7d8dd4a9.svg";